// Production CMS is served from the bare `tcms` host; dev/staging carry a
// suffix (tcms-dev / tcms-staging) and local runs on localhost. Used to gate
// features that aren't ready for production yet.
const PROD_CMS_HOST = 'tcms.tennischannel.com'

/** True only when running as the production CMS deployment. */
export function isProdEnv(): boolean {
  const configured = import.meta.env.VITE_CMS_WEBSITE_URL as string | undefined
  if (configured) {
    try {
      return new URL(configured).hostname === PROD_CMS_HOST
    } catch {
      // malformed URL — fall through to the live hostname check
    }
  }
  return (
    typeof window !== 'undefined' &&
    window.location.hostname === PROD_CMS_HOST
  )
}
